/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ companyName: NonNullable<unknown> }} General_Loginheader1Inputs */

const en_general_loginheader1 = /** @type {(inputs: General_Loginheader1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sign in to the ${i?.companyName} Workbench`)
};

/**
* | output |
* | --- |
* | "Sign in to the {companyName} Workbench" |
*
* @param {General_Loginheader1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const general_loginheader1 = /** @type {((inputs: General_Loginheader1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<General_Loginheader1Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_general_loginheader1(inputs)
});
export { general_loginheader1 as "general_loginHeader" }